import React from 'react';
import styles from './LiveChatUnavailable.module.css';
import { format } from '../helpers';
import liveChatConfig from '../resources/liveChatConfig.json';

export interface LiveChatUnavailableData {
    closedReason: string | undefined;
    availableHours: string | undefined;
}

export const LiveChatUnavailable: React.FC<{
    data: LiveChatUnavailableData;
}> = ({ data }) => {
    const agentsAvatars = ['agent_1.png', 'agent_2.png', 'agent_3.png'];
    let subTitle: string;
    let bodyMessage: string;

    if (data.closedReason == 'OUTSIDE_HOURS') {
        subTitle = format(liveChatConfig.providence.availableHours, {
            availableHours: data.availableHours || '',
        });
        bodyMessage = liveChatConfig.providence.backAtRegularHours;
    } else {
        subTitle = liveChatConfig.providence.unavailable;
        bodyMessage = '';
    }

    return (
        <div className={styles.liveChatUnavailableContainer}>
            <p className={styles.liveChatUnavailableTitle}>Live Chat</p>
            <p className={styles.liveChatUnavailableSubtitle}>{subTitle}</p>
            <div className={styles.liveChatUnavailableBody}>
                <div className={styles.liveChatUnavailableAgentAvatars}>
                    {agentsAvatars.length > 0 &&
                        agentsAvatars
                            .slice(0, Math.min(3, agentsAvatars.length))
                            .map((avatar, index) => {
                                return (
                                    <div
                                        className={
                                            styles.liveChatUnavailableAgentAvatar
                                        }
                                        key={`avatar_${index}`}
                                    >
                                        <img src={'/' + avatar} />
                                    </div>
                                );
                            })}
                </div>
                <p className={styles.liveChatUnavailableBodyMessage}>
                    {bodyMessage}
                </p>
            </div>
        </div>
    );
};
